import {
    SET_SERVICEABILITY_LOADER,
    SET_SERVICEABILITY_LIST
} from '../actionTypes/serviceabilityActionType';

const initialState: any = {
    isLoading: false,
    serviceabilityData: {},
}

const serviceabilityReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SERVICEABILITY_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }
        case SET_SERVICEABILITY_LIST:
            return {
                ...state,
                serviceabilityData: action.payload
            }
        default:
            return state;
    }
}

export default serviceabilityReducer